import { selectorFamily, atomFamily } from 'recoil';
import { ObeService } from 'api';
import getCustomer from 'api/customers/getCustomer';
import { DEFAULT_LANGUAGE } from 'constants/language';
import { mapGetVehicleInformationResponseToIVehicleInformation } from 'utils/mapping/mapVehicles';
export const registrationNumber = atomFamily({
  key: 'registrationNumberAtom',
  default: ''
});
export const vehicleInformation = atomFamily({
  key: 'vehicleInformation',
  default: null
});
export const getVehicleInformation = selectorFamily({
  key: 'getVehicleInformation',
  get: ({
    customerId,
    vehicleFormId
  }) => async ({
    get
  }) => {
    const licensePlateNumber = get(registrationNumber(vehicleFormId));
    const customer = get(getCustomer(customerId));

    // Only norwegian vehicles should use this functionality.
    if (licensePlateNumber && customer) {
      const body = {
        userId: customer.id,
        licensePlateNumber,
        country: DEFAULT_LANGUAGE,
        firstName: customer?.personFirstName,
        lastName: customer?.personLastName,
        companyNumber: customer?.organizationNumber
      };
      try {
        const res = await ObeService.getVehicleInformation({
          body
        });

        // Could not find a vehichle with this registration number
        if (!res.carPlate) throw Error('Could not find any vehicle');
        return mapGetVehicleInformationResponseToIVehicleInformation(res);
      } catch (e) {
        throw Error(`Error fetching vehicle for ${licensePlateNumber}`);
      }
    }
    return get(vehicleInformation(vehicleFormId));
  }
});